import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useOutletContext } from "react-router";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import axios from "axios";
import moment from "moment";

import { useModal } from "../../../../hooks/useModal";

import List from "./common/list";
import HelpForm from "./common/helpForm";

import { FaBars } from "react-icons/fa6";

const Help = ({ setImages, setIsDetail }) => {
  const navigate = useNavigate();

  const contentRef = useRef();

  const { url, cmpnyNo } = useOutletContext();

  const user = useSelector((state) => state?.user?.data[0]);

  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);
  const [page, setPage] = useState(1);
  const [inquiries, setInquiries] = useState([]);
  const [total, setTotal] = useState(0);
  const [formData, setFormData] = useState({ title: "", content: "" });

  const { modal, openModal, closeModal } = useModal();

  useEffect(() => {
    if (!user) {
      toast.error("로그인 후 이용 가능합니다.", { toastId: "no-access" });
      navigate(`/shop${url ? `/${url}` : ""}/login`, {
        state: { path: "shoppingNotice", tabIndex: 1 },
      });
    } else {
      getInquiries();
    }
  }, []);

  // 문의 리스트 조회
  const getInquiries = async (page = 1) => {
    if (loading) return;

    const url = "/erp/inquiryList";
    const body = {
      mberNo: user.mberNo,
      cmpnyNo,
      page: page,
      limit: 10,
    };

    try {
      setLoading(true);
      const res = await axios.post(url, body);

      setInquiries(res.data.inquiry || []);
      setTotal(res.data.totalCount || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // 페이지 변경
  const changePage = async (newPage) => {
    setPage(newPage);
    await getInquiries(newPage);
  };

  const header = [
    { name: "번호", key: "id" },
    { name: "제목", key: "title" },
    {
      name: "답변상태",
      key: "status",
      content: (item) => (
        <div className={`status`}>
          <span className={item.status ? "completion" : "pending"}>
            {item.status ? "답변완료" : " 대기"}
          </span>
        </div>
      ),
    },
    {
      name: "등록일",
      key: "createDt",
      content: (item) => (
        <span className="createDt">
          {moment(item.updateDt || item.createDt).format("YYYY-MM-DD HH:mm")}
        </span>
      ),
    },
  ];

  const cancelEvent = () => {
    setActive(0);
    setFormData({ title: "", content: "" });
  };

  return (
    <>
      {modal}
      {
        [
          <>
            <div className="count">
              <FaBars />
              문의글
              <strong> {total}</strong>
              개가 등록되어 있습니다.
            </div>
            <List
              data={inquiries}
              header={header}
              type="1:1 문의"
              clickEvent={(item) => navigate(`/shop/${url}/helpView/${item.id}`)}
              className="notice"
            />
            <div className="buttons end">
              <button onClick={() => setActive(1)}>문의글 작성</button>
            </div>
            {inquiries && inquiries.length > 0 && (
              <Pagination
                activePage={page}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={3}
                prevPageText={"‹"}
                nextPageText={"›"}
                onChange={changePage}
              />
            )}
          </>,
          <HelpForm
            setActive={setActive}
            formData={formData}
            setFormData={setFormData}
            openModal={openModal}
            closeModal={closeModal}
            getInquiries={getInquiries}
            cancelEvent={cancelEvent}
          />,
        ][active]
      }
    </>
  );
};

export default Help;
